import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/analytics';
import { types as typesApp } from '../../actions/app';

const initialState = null;

const handleNewSession = (state, action) => action.payload.data.sessionId;
const handleSetSessionId = (state, action) => action.payload.sessionId;

const handlers = {
  [types.ANALYTICS_NEW_SESSION.SUCCESS]: handleNewSession,
  [typesApp.APP_SET_SESSION_ID]: handleSetSessionId,
};

const sessionId = createReducer(initialState, handlers);

export default sessionId;

export const getSessionId = state => state.app.sessionId;



// WEBPACK FOOTER //
// ./src/reducers/app/sessionId.js